const SkillsData = [
  {
    name: "HTML",
    image: require("../assets/Images/html.png"),
  },
  {
    name: "CSS",
    image: require("../assets/Images/css.png"),
  },
  {
    name: "JavaScript",
    image: require("../assets/Images/javascript.png"),
  },
  {
    name: "TypeScript",
    image: require("../assets/Images/typescript.png"),
  },
  {
    name: "MongoDB",
    image: require("../assets/Images/mongodb.png"),
  },
  {
    name: "Express",
    image: require("../assets/Images/express.png"),
  },
  {
    name: "React",
    image: require("../assets/Images/react.png"),
  },
  {
    name: "Node",
    image: require("../assets/Images/node.png"),
  },
  {
    name: "Redux",
    image: require("../assets/Images/redux.png"),
  },
  {
    name: "Next",
    image: require("../assets/Images/next.png"),
  },
  {
    name: "Tailwind",
    image: require("../assets/Images/tailwind.png"),
  },
  {
    name: "Firebase",
    image: require("../assets/Images/firebase.png"),
  },
  {
    name: "Prisma",
    image: require("../assets/Images/prisma.png"),
  },
  {
    name: "MySQL",
    image: require("../assets/Images/mysql.png"),
  },
  {
    name: "Postman",
    image: require("../assets/Images/postman.png"),
  },
  {
    name: "VS Code",
    image: require("../assets/Images/vscode.png"),
  },
  {
    name: "Git",
    image: require("../assets/Images/git.png"),
  },
  {
    name: "GitHub",
    image: require("../assets/Images/github.png"),
  },
];

export default SkillsData;
